var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcongov(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5961 25L19.6726 19.2M22.8726 11.6667C22.8726 17.5577 17.9953 22.3333 11.9788 22.3333C5.9623 22.3333 1.08496 17.5577 1.08496 11.6667C1.08496 5.77563 5.9623 1 11.9788 1C17.9953 1 22.8726 5.77563 22.8726 11.6667Z",
    stroke: "#0065B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcongov);
export default __webpack_public_path__ + "static/media/search_icon.gov.dafe57ab36e5a7b74f252f0c950f6905.svg";
export { ForwardRef as ReactComponent };